// TailorWiz wordmark: "Tailor" in navy, "Wiz" in gold, heavy grotesque, tight
// tracking. Recreated as vector text from Marcus's approved logo (Oct 2026)
// so it stays crisp at every size; colours sampled from that file.
export const BRAND_NAVY = "#000F36";
export const BRAND_GOLD = "#CD9700";

export function TailorWizLogo({
  height = 32,
  tagline = false,
  className = "",
}: {
  height?: number;
  tagline?: boolean;
  className?: string;
}) {
  const w = 300;
  const h = tagline ? 96 : 72;
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      height={height}
      width={(height * w) / h}
      className={className}
      role="img"
      aria-label="TailorWiz"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        x="0"
        y="58"
        textLength={w}
        lengthAdjust="spacingAndGlyphs"
        fontFamily="Inter, 'Helvetica Neue', Arial, sans-serif"
        fontWeight="800"
        fontSize="74"
        letterSpacing="-3"
      >
        <tspan fill={BRAND_NAVY}>Tailor</tspan>
        <tspan fill={BRAND_GOLD}>Wiz</tspan>
      </text>
      {tagline && (
        <text
          x="2"
          y="90"
          textLength={w - 4}
          lengthAdjust="spacingAndGlyphs"
          fontFamily="Inter, 'Helvetica Neue', Arial, sans-serif"
          fontWeight="600"
          fontSize="18"
          fill="#5B6478"
        >
          Tailor your resume to any job
        </text>
      )}
    </svg>
  );
}
